export const ALERT_TYPES = {
  WARNING: 'warning',
  ERROR: 'error',
};
